import { render, staticRenderFns } from "./CheckcodeInput.vue?vue&type=template&id=52c2b846&scoped=true&"
import script from "./CheckcodeInput.vue?vue&type=script&lang=ts&"
export * from "./CheckcodeInput.vue?vue&type=script&lang=ts&"
import style0 from "./CheckcodeInput.vue?vue&type=style&index=0&id=52c2b846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2b846",
  null
  
)

export default component.exports